import { GuideSteps } from './guideData';

export const tourSteps = [
  {
    target: null,
    title: 'Welcome to the Tour',
    content: 'This quick tour walks you through the main sections of the cricket editor and the recommended order for setting up your data.',
    placement: 'center',
  },
  ...GuideSteps.map((step) => ({
    target: `[data-tour="tour-${step.key}"]`,
    title: `Step ${step.stepNumber}: ${step.name}`,
    content: step.shortDescription,
    placement: 'bottom',
  })),
  {
    target: '[data-tour="tour-guide-link"]',
    title: 'Editor Guide',
    content: 'You can always revisit the full setup guide from here. It shows the recommended resource creation order with links to create and view each entity.',
    placement: 'bottom-end',
  },
];
